import consumer from './consumer';
import { log } from '../utils/logger';

// #AI: NProgress is loaded via Sprockets as a global variable
// Check if it's available before using it (mobile browser compatibility)
const NProgress = window.NProgress;

consumer.subscriptions.create('LoadingIndicatorChannel', {
  connected() {
    log('connected to LoadingIndicatorChannel');
  },

  disconnected() {
    log('connected to LoadingIndicatorChannel');
  },

  received(data) {
    log('message received from LoadingIndicatorChannel', data);

    if (!NProgress) {
      log('NProgress not available, skipping loading indicator');
      return;
    }

    if (data.status === 'start') {
      NProgress.start();
    } else {
      NProgress.done();
    }
  },
});
